import { render, staticRenderFns } from "./Received.vue?vue&type=template&id=97985096&scoped=true"
import script from "./Received.vue?vue&type=script&lang=js"
export * from "./Received.vue?vue&type=script&lang=js"
import style0 from "./Received.vue?vue&type=style&index=0&id=97985096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97985096",
  null
  
)

export default component.exports